import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import GhlFormModal, { GHL_FORMS } from './components/GhlFormModal';
import CookieBanner from './components/CookieBanner';
import { GA_ID } from './consent';
import Home from './pages/Home';
import About from './pages/About';
import WorkWithMe from './pages/WorkWithMe';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import ForCompanies from './pages/ForCompanies';
import { useLocation } from './router';
import { NewsletterContext } from './newsletter';

const pages: Record<string, { component: React.FC; title: string }> = {
  '/': { component: Home, title: 'Hanna Kinez — Executive Performance Coach' },
  '/about': { component: About, title: 'About — Hanna Kinez' },
  '/work-with-me': { component: WorkWithMe, title: 'Work With Me — Hanna Kinez' },
  '/resources': { component: Resources, title: 'Resources — Hanna Kinez' },
  '/contact': { component: Contact, title: 'Contact — Hanna Kinez' },
  '/privacy': { component: Privacy, title: 'Privacy Policy — Hanna Kinez' },
  '/office': { component: ForCompanies, title: 'Workshops for Tech Teams — Hanna Kinez' },
};

function App() {
  const { path, hash, key } = useLocation();
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
  const page = pages[path] ?? pages['/'];
  const Page = page.component;

  useEffect(() => {
    document.title = page.title;

    // Scroll to the #anchor if there is one, otherwise to the top of the new page.
    const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }

    if (window.gtag) {
      window.gtag('config', GA_ID, {
        page_title: page.title,
        page_location: window.location.href,
      });
    }
  }, [path, hash, key, page.title]);

  return (
    <NewsletterContext.Provider value={() => setIsNewsletterOpen(true)}>
      <div className="App">
        {path !== '/office' && <Header path={path} />}
        <main className={path === '/office' ? 'main--no-header' : undefined}>
          <Page />
        </main>
        <Footer />
      </div>
      <CookieBanner />
      <GhlFormModal
        isOpen={isNewsletterOpen}
        onClose={() => setIsNewsletterOpen(false)}
        form={GHL_FORMS.kinezioletter}
        title="The KinezioLetter"
        intro="Every two weeks: the tools, protocols and body hacks I use with private clients. No fluff."
      />
    </NewsletterContext.Provider>
  );
}

export default App;
